var _g, _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorefront({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#paint0_linear_storefront)",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 13L10.5 4H37.5L44 13H4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13V16C4 18.761 6.239 21 9 21C11.761 21 14 18.761 14 16C14 18.761 16.239 21 19 21C21.761 21 24 18.761 24 16C24 18.761 26.239 21 29 21C31.761 21 34 18.761 34 16C34 18.761 36.239 21 39 21C41.761 21 44 18.761 44 16V13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21V41C7 42.657 8.343 44 10 44H38C39.657 44 41 42.657 41 41V21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 26H19.5L22 34.5H30.5L32 28.5H20.5"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 38.5,
    r: 1.6,
    fill: "url(#paint0_linear_storefront)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 38.5,
    r: 1.6,
    fill: "url(#paint0_linear_storefront)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_storefront",
    x1: 24,
    y1: 4,
    x2: 24,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85329A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#477CCA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorefront);
export default __webpack_public_path__ + "static/media/storefront.602ebce073fd85c8bb9703915a3695cf.svg";
export { ForwardRef as ReactComponent };